import React, { forwardRef } from 'react'

import clsx from 'clsx'
import styled from 'styled-components'
import { Spin, Pagination, Tooltip, Popover } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import './styles.scss'

export const GroupNodeWrapper = styled.div.attrs(({ level = 0, isSelected = false, isExpanded = false }) => ({
  className: clsx('node group-node', {
    'group-node-expanded': isExpanded,
    'group-node-root': level === 0,
    'group-node-selected': isSelected,
  }),
  style: {
    '--level': level,
  },
}))``

export const GroupNodeHeader = styled.a.attrs({
  className: 'group-node-header',
})``

export const GroupNodeHeaderLeft = styled.div.attrs({
  className: 'group-node-header-left',
})``

export const GroupNodeHeaderIcon = styled.div.attrs(({ visible = true }) => ({
  className: clsx('group-node-header-icon', {
    'group-node-header-icon-hidden': !visible,
  }),
}))``

export const GroupNodeHeaderName = forwardRef((props, ref) => {
  const { tooltip, children, ...rest } = props

  const content = () => (
    <div ref={ref} className="group-node-header-name" {...rest}>
      {children}
    </div>
  )

  if (!tooltip) {
    return content()
  }

  return (
    <Tooltip title={tooltip} overlayClassName="node-tooltip">
      {content()}
    </Tooltip>
  )
})

export const GroupNodeHeaderActions = styled.div.attrs({
  className: 'group-node-header-actions',
})``

export const GroupNodeHeaderAction = styled.div.attrs({
  className: 'group-node-header-action',
})``

export const GroupNodeContent = styled.div.attrs({
  className: 'group-node-content',
})``

export const DeviceNodeWrapper = forwardRef((props, ref) => {
  const {
    level = 0,
    isSelected = false,
    isInactive = false,
    children,
    tooltip,
    ...rest
  } = props

  const className = clsx(
    'node device-node',
    {
      'device-node-root': level === 0,
      'device-node-selected': isSelected,
      'device-node-inactive': isInactive,
    },
    props.className
  )

  const style = {
    '--level': level,
    ...props.style,
  }

  const content = () => (
    <a ref={ref} {...rest} className={className} style={style}>
      {children}
    </a>
  )

  if (!tooltip) {
    return content()
  }

  return (
    <Tooltip title={tooltip} overlayClassName="node-tooltip">
      {content()}
    </Tooltip>
  )
})

export const DeviceNodeIcon = styled.div.attrs({
  className: 'device-node-icon',
})``

export const DeviceNodeName = styled.div.attrs({
  className: 'device-camera-name',
})``

export const DeviceNodeActions = styled.div.attrs({
  className: 'device-node-actions',
})``

export const DeviceNodeAction = styled.div.attrs(({ active = false }) => ({
  className: clsx('device-node-action', { active }),
}))``

export const GroupChildrenLoading = () => (
  <div className="group-node-children-loading">
    <Spin indicator={<LoadingOutlined />} />
  </div>
)

const PAGE_THREADHOLD = 99

export const GroupPagination = (props) => {
  const total = props.total ?? 0
  const totalPages = Math.ceil(total / (props.pageSize ?? 1))

  return (
    <Pagination
      size="small"
      simple={totalPages > PAGE_THREADHOLD}
      showSizeChanger={false}
      {...props}
      className={clsx(props.className, 'group-pagination')}
    />
  )
}

export const NodeActionItem = ({
  icon,
  onClick,
  label,
  className,
  danger,
}) => {
  return (
    <button
      className={clsx('node-action-item', className, { danger })}
      onClick={onClick}
    >
      <span className="node-action-item-icon">{icon}</span>
      {label}
    </button>
  )
}

export const NodeActionItems = styled.div.attrs({
  className: 'node-action-items',
})``

export const NodeActionPopover = (props) => {
  return (
    <Popover
      trigger="click"
      placement="rightTop"
      align={{ offset: [2, -8] }}
      overlayStyle={{ zIndex: 10002 }}
      {...props}
      overlayClassName={clsx(
        props.overlayClassName,
        'node-action-items-overlay'
      )}
    >
      {props.children}
    </Popover>
  )
}
